import { isEmpty, round } from "lodash";
import { singleValue, isBulkFootage } from "../../../utils";

const pogDataUpdater = (updatedDetails, pog = {}, details = {}) => {
  // setting selected value present then:
  // 1. 'Y' - do calculations carry forward/update adj LF from pog and pog Notes
  // 2. 'N' - reset calculated values and adj LF except Notes
  if (!!details.selected) {
    // Settings selected 'Y'
    if ([singleValue.yes].includes(details?.selected)) {
      let updatedPog = {
        storePlanogramId: pog?.PlanogramNumber,
        selected: !isEmpty(details.selected) ? details.selected : pog.Selected, // Mandatory
        releaseStatus: pog?.ReleaseStatus,
        releaseDate: pog?.ReleaseDate,
        departmentLetter: pog?.DepartmentLetter,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }

    // Settings selected 'N'
    if ([singleValue.no].includes(details?.selected)) {
      let updatedPog = {
        storePlanogramId: pog?.PlanogramNumber,
        selected: details?.selected, // Mandatory
        releaseDate: null,
        releaseStatus: "",
        poNumber: "",
        departmentLetter: pog?.DepartmentLetter,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }
  } else {
    // Perform updates based on pog selected AND settings values(except settings 'selected') value as:
    // 1. pog 'Y' - do calculations carry forward/update adj LF and Notes
    // 2. pog 'N' - reset calculated values and adj LF except Notes (skip settings values)

    // Settings selected 'Y'
    if ([singleValue.yes].includes(pog?.Selected)) {
      let updatedPog = {
        storePlanogramId: pog?.PlanogramNumber,
        selected: !isEmpty(details.selected) ? details.selected : pog.Selected, // Mandatory
        releaseStatus: pog?.ReleaseStatus,
        releaseDate: pog?.ReleaseDate,
        departmentLetter: pog?.DepartmentLetter,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }

    // Settings selected 'N'
    if ([singleValue.no].includes(pog?.Selected)) {
      let updatedPog = {
        storePlanogramId: pog?.PlanogramNumber,
        selected: pog.Selected, // Mandatory
        releaseDate: null,
        releaseStatus: "",
        poNumber: "",
        departmentLetter: pog?.DepartmentLetter,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }
  }
  return updatedDetails;
};

export default pogDataUpdater;
